// The host seam (ADR-101): how a shared component reaches the shell it is mounted in. A primitive
// or library screen never imports a shell's router or help registry; it asks the nearest Host how
// to navigate and where a help topic's article lives. Each shell provides one at its root. Outside
// a provider the default behaves like a plain web page: a navigation is a full page load, and no
// topic has an article, so help buttons render nothing.
import { createContext } from "preact";
import { useContext } from "preact/hooks";

export interface Host {
  kind: "allcode-admin" | "proxy-admin-area";
  /** The path the shell mounts the shared screens under ("" for the AllCode admin, "/admin" on the proxy). */
  basePath: string;
  /** A client-side navigation to a same-origin path. */
  navigate(href: string): void;
  /** Where the article behind a help topic lives in this shell, or null when it has none. */
  helpHref(topic: string): string | null;
}

export const DEFAULT_HOST: Host = {
  kind: "allcode-admin",
  basePath: "",
  navigate: (href) => location.assign(href),
  helpHref: () => null,
};

export const HostContext = createContext<Host>(DEFAULT_HOST);

export function useHost(): Host {
  return useContext(HostContext);
}

/** Whether a click on a same-origin link should become a client-side navigation. */
export function isPlainLeftClick(event: {
  button: number;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
  defaultPrevented: boolean;
}): boolean {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.defaultPrevented;
}
